<template>
  <div class="vlogin">
    <!-- Panel de marca -->
    <aside class="vlogin__brand">
      <div class="vlogin__brand-top">
        <img :src="'/vistar-logo.png'" alt="Vistar" class="vlogin__brand-mark" />
        <span class="vlogin__brand-wordmark">Vistar</span>
      </div>

      <div class="vlogin__brand-center">
        <span class="vlogin__brand-eyebrow">Clínica Oftalmológica</span>
        <h1 class="vlogin__brand-title">Panel de <em>administración</em></h1>
        <p class="vlogin__brand-sub">
          Gestiona el contenido, los doctores, los servicios y el blog
          de la clínica desde un solo lugar.
        </p>
      </div>

      <div class="vlogin__brand-foot">
        © {{ year }} Vistar · Ciudad Juárez, México
      </div>
    </aside>

    <!-- Panel de formulario -->
    <main class="vlogin__form">
      <div class="vlogin__form-inner">
        <div class="vlogin__mobile-brand">
          <img :src="'/vistar-logo.png'" alt="Vistar" />
          <span>Vistar</span>
        </div>

        <Login
            :options="{ password: { enabled: true, url: '/login' } }"
            @onSubmit="onSubmit"
            @onError="onError" />
      </div>
    </main>
  </div>
</template>

<script>
import Login from './Login.vue';

export default {
  components: { Login },
  inject: ['$cookies'],
  data: () => ({ year: new Date().getFullYear() }),
  methods: {
    onSubmit(response) {
      this.$cookies.set('zensavvy_session_token', response.session_token)

      this.$swal.fire({
        icon: 'success',
        title: '¡Bienvenido!',
        text: 'Estamos iniciando sesión, espera un momento…'
      })

      setTimeout(() => {
        window.location.href = '/app'
      }, 1250)
    },
    onError(e) {
      this.$swal.fire({
        icon: 'error',
        title: 'Oops…',
        text: 'Credenciales inválidas.'
      })
    }
  }
};
</script>
